const UPDATE = (state, data) => {
  state[data.key] = data.value

  let user = localStorage.getItem("__crrntUser")

  if (user) {
    user = JSON.parse(user)

    let sObj = user.settings.find((i) => i.key == data.key)
    let sIndex = user.settings.findIndex((i) => i.key == data.key)

    if (sObj) {
      sObj.value = data.value
    } else {
      sObj = {}
      sObj.key = data.key
      sObj.value = data.value
      sIndex = user.settings.length
    }

    user.settings[sIndex] = sObj

    localStorage.setItem("__crrntUser", JSON.stringify(user))
  }
}

export default {
  UPDATE
}
